import { render, staticRenderFns } from "./DataInput.vue?vue&type=template&id=4dd53e47&"
import script from "./DataInput.vue?vue&type=script&lang=js&"
export * from "./DataInput.vue?vue&type=script&lang=js&"
import style0 from "./DataInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports